import React, { useState } from 'react';

const styles = {
  section: { padding: 'clamp(60px, 10vh, 100px) 0', backgroundColor: '#f4f7f9' },
  container: { width: '90%', maxWidth: '1200px', margin: '0 auto' },
  heading: { 
    textAlign: 'center', 
    fontSize: 'clamp(2.2rem, 5vw, 3rem)', 
    color: '#1a3a5a', 
    marginBottom: '10px',
    fontWeight: '900' 
  },
  divider: { width: '80px', height: '5px', background: '#d4af37', margin: '0 auto 60px auto', borderRadius: '10px' },
  contactWrapper: { display: 'flex', gap: '50px', flexWrap: 'wrap' },
  infoBox: { flex: '1', minWidth: '320px', background: '#1a3a5a', color: '#fff', padding: '45px', borderRadius: '20px' },
  subHeading: { 
    color: '#d4af37', 
    marginBottom: '30px', 
    fontSize: 'clamp(1.4rem, 2vw, 1.8rem)', 
    fontWeight: '800'
  },
  infoItem: { 
    display: 'flex', 
    gap: '20px', 
    marginBottom: '25px', 
    alignItems: 'center',
    fontSize: 'clamp(1.05rem, 1.2vw, 1.2rem)', 
    fontWeight: '500'
  },
  icon: { fontSize: '1.5rem' },
  mapContainer: { marginTop: '30px' },
  formBox: { flex: '1.5', minWidth: '320px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  input: { 
    padding: '18px', 
    borderRadius: '12px', 
    border: '1px solid #ddd', 
    fontSize: '1.1rem', 
    outline: 'none',
    fontWeight: '500'
  },
  textarea: { 
    padding: '18px', 
    borderRadius: '12px', 
    border: '1px solid #ddd', 
    fontSize: '1.1rem', 
    outline: 'none', 
    resize: 'none',
    fontWeight: '500'
  },
  submitBtn: { 
    padding: '20px', 
    background: '#d4af37', 
    color: '#1a3a5a', 
    border: 'none', 
    borderRadius: '12px', 
    fontWeight: '900', 
    cursor: 'pointer', 
    fontSize: '1.2rem', 
    transition: '0.3s'
  },
  statusText: { 
    textAlign: 'center', 
    marginTop: '20px', 
    color: '#1a3a5a', 
    fontWeight: '800',
    fontSize: '1.1rem',
    padding: '12px',
    borderRadius: '10px',
    backgroundColor: 'rgba(26, 58, 90, 0.05)'
  }
};

const Contact = ({ lang, t }) => {
  const isRtl = lang === 'ar';
  
  // نتحقق إذا كان المستخدم عاد للموقع بعد الإرسال بنجاح
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get('status') === 'success';

  return (
    <section id="contact" style={{...styles.section, direction: isRtl ? 'rtl' : 'ltr'}}>
      <div style={styles.container}>
        <h2 style={styles.heading}>{t?.nav?.contact || (isRtl ? 'تواصل معنا' : 'Contact Us')}</h2>
        <div style={styles.divider}></div>

        <div style={{...styles.contactWrapper, flexDirection: isRtl ? 'row-reverse' : 'row'}}>
          
          <div style={{...styles.infoBox, textAlign: isRtl ? 'right' : 'left'}}>
            <h3 style={styles.subHeading}>{isRtl ? 'موقع المصنع وتواصلنا' : 'Location & Contact'}</h3>
            <div style={styles.infoItem}><span style={styles.icon}>📍</span><p>{isRtl ? '18/2 المنطقة الحرفية، مدينة بدر، القاهرة' : '18/2 Al-Harafiya, Badr City, Cairo'}</p></div>
            <div style={styles.infoItem}><span style={styles.icon}>📞</span><p style={{direction: 'ltr'}}>+20 2 28590490</p></div>
            <div style={styles.infoItem}><span style={styles.icon}>✉️</span><p>info@yam-ii.com</p></div>
            <div style={styles.infoItem}><span style={styles.icon}>🌐</span><p><a href="https://yam-ii.com" target="_blank" rel="noreferrer" style={{color: '#d4af37', textDecoration: 'none'}}>www.yam-ii.com</a></p></div>

            {/* قسم الخريطة - كما هو في الكود الأصلي لم يلمس */}
            <div style={styles.mapContainer}>
              <iframe
                title="YAM International Industries Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3451.81525754859!2d31.759316175481716!3d30.122296274885834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458f117f90a592d%3A0xdd6b346f39e0efc1!2sYAM%20International%20Industries!5e0!3m2!1sen!2seg!4v1700000000000!5m2!1sen!2seg"
                width="100%" height="280" style={{ border: 0, borderRadius: '15px' }}
                allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div style={styles.formBox}>
            {/* تم تحويل الفورم للإرسال المباشر لضمان العمل على كل المتصفحات */}
            <form 
              style={styles.form} 
              action="https://yam-ii.com/yam_api/send_maily.php" 
              method="POST"
            >
              <input 
                type="text" 
                name="name"
                required 
                placeholder={isRtl ? 'الاسم بالكامل' : 'Full Name'} 
                style={{...styles.input, textAlign: isRtl ? 'right' : 'left'}} 
              />
              <input 
                type="email" 
                name="email"
                required 
                placeholder={isRtl ? 'البريد الإلكتروني' : 'Email'} 
                style={{...styles.input, textAlign: isRtl ? 'right' : 'left'}} 
              />
              <textarea 
                name="message"
                required 
                placeholder={isRtl ? 'رسالتك' : 'Your Message'} 
                rows="6" 
                style={{...styles.textarea, textAlign: isRtl ? 'right' : 'left'}}
              ></textarea>
              <button type="submit" style={styles.submitBtn}>
                {isRtl ? 'إرسال الآن' : 'Send Now'}
              </button>
              
              {/* رسالة النجاح التي تظهر بعد عودة المستخدم من ملف PHP */}
              {isSuccess && (
                <div style={{...styles.statusText, color: '#28a745'}}>

                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;